import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Table, Card, Input, Grid, Button, Dropdown, Loader} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import {pageSizes} from '../../../../common/constants/lists';
import {enterKeyCode} from '../../../../common/constants/keyCodes';
import {buildParameters} from '../../../../common/util/parametersUtils';
import TablePaginator from '../../../../common/components/tablePaginator';
import './partsAnalysisList.scss';

class PartsAnalysisList extends Component {
  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onCodeFilterChange = this.onCodeFilterChange.bind(this);
    this.checkEnterSubmit = this.checkEnterSubmit.bind(this);
    this.onDescriptionFilterChange = this.onDescriptionFilterChange.bind(this);
    this.onMotorFilterChange = this.onMotorFilterChange.bind(this);
    this.onBrandFilterChange = this.onBrandFilterChange.bind(this);
    this.onOriginFilterChange = this.onOriginFilterChange.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onViewPart = this.onViewPart.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartAnalysis,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changePartsListPage(0);
    this.props.clearFilters();
  }

  checkEnterSubmit(event) {
    if (event.keyCode === enterKeyCode) {
      this.onSearch(0);
    }
  }

  onCodeFilterChange(event) {
    this.props.changeCodeTextFilter(event.target.value);
  }

  onDescriptionFilterChange(event) {
    this.props.changeDescriptionTextFilter(event.target.value);
  }

  onMotorFilterChange(event) {
    this.props.changeMotorTextFilter(event.target.value);
  }

  onBrandFilterChange(event) {
    this.props.changeBrandTextFilter(event.target.value);
  }

  onOriginFilterChange(event) {
    this.props.changeOriginTextFilter(event.target.value);
  }

  onCancelClick() {
    this.props.clearFilters();
    this.props.changePartsListPage(0);
  }

  getPartsList(pageNumber, pageSize) {
    const parameters = buildParameters(this.props);
    this.props.fetchAnalysisList(parameters, pageSize, pageNumber);
  }

  onSearch(value) {
    const {pageSize} = this.props;
    this.props.changePartsListPage(value);
    this.getPartsList(value, pageSize);
  }

  onPageSizeClick(event, data) {
    this.props.changePartsListPageSize(data.value);
    this.getPartsList(0, data.value);
  }

  onViewPart(code) {
    this.props.navigateTo(`/partes/analisis/editar/${code}`);
  }

  renderParts(list) {
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      return (
        <Table.Row key={index} onClick={() => this.onViewPart(element.code)}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>{element.motor}</Table.Cell>
          <Table.Cell textAlign='center'>{element.chassis}</Table.Cell>
          <Table.Cell textAlign='center'>{element.brand}</Table.Cell>
          <Table.Cell textAlign='center'>{element.model}</Table.Cell>
          <Table.Cell textAlign='center'>{element.origin}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {
      loading,
      parts,
      filterCodeText,
      filterDescriptionText,
      filterMotorText,
      filterBrandText,
      filterOriginText,
      pageNumber,
      pageSize,
      partsCount,
    } = this.props;
    return (
      <div className='parts-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <h2 className='title-bar-text'>Análisis de partes</h2>
            <p className='title-bar-description'>
              Puede realizar la búsqueda ingresando uno o más de los siguientes
              parámetros:
            </p>
            <div className='title-bar-actions'>
              <Grid columns='equal'>
                <Grid.Row>
                  <Grid.Column>
                    <Input
                      placeholder='Por código'
                      value={filterCodeText}
                      onChange={this.onCodeFilterChange}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      placeholder='Por descripción'
                      value={filterDescriptionText}
                      onChange={this.onDescriptionFilterChange}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      placeholder='Por motor o chasis'
                      value={filterMotorText}
                      onChange={this.onMotorFilterChange}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      placeholder='Por marca o modelo'
                      value={filterBrandText}
                      onChange={this.onBrandFilterChange}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      placeholder='Por origen'
                      value={filterOriginText}
                      onChange={this.onOriginFilterChange}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      type='button'
                      secondary
                      className='toyota-secondary'
                      onClick={this.onCancelClick}
                    >
                      Limpiar
                    </Button>
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      primary
                      type='submit'
                      className='toyota-primary'
                      onClick={() => this.onSearch(0)}
                    >
                      Buscar
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Descripción
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Motor</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Chasis</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Marca</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Modelo</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Origen</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {loading && (
                <Table.Row>
                  <Table.Cell colSpan='100%'>
                    <Loader active inline='centered' />
                  </Table.Cell>
                </Table.Row>
              )}
              {!loading && this.renderParts(parts)}
            </Table.Body>

            {!(partsCount <= pageSize) && (
              <Table.Footer>
                <Table.Row textAlign='center'>
                  <Table.HeaderCell colSpan='100%'>
                    <div className='table-pagination'>
                      <span className='page-sizer'>
                        <strong>Items por página</strong>
                        <Dropdown
                          selection
                          upward
                          compact
                          value={pageSize}
                          options={pageSizes}
                          onChange={this.onPageSizeClick}
                        />
                      </span>
                      <TablePaginator
                        itemsCount={partsCount}
                        itemsPerPage={pageSize}
                        selectedPage={pageNumber}
                        onOptionClick={this.onSearch}
                      />
                    </div>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            )}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.parts.loading,
    'parts': state.parts.page,
    'filterCodeText': state.parts.filterCodeText,
    'filterDescriptionText': state.parts.filterDescriptionText,
    'filterMotorText': state.parts.filterMotorText,
    'filterBrandText': state.parts.filterBrandText,
    'filterOriginText': state.parts.filterOriginText,
    'pageNumber': state.parts.pageNumber,
    'pageSize': state.parts.pageSize,
    'partsCount': state.parts.itemsCount,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchAnalysisList,
  clearFilters,
  changeCodeTextFilter,
  changeDescriptionTextFilter,
  changeMotorTextFilter,
  changeBrandTextFilter,
  changeOriginTextFilter,
  changePartsListPage,
  changePartsListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchAnalysisList,
  clearFilters,
  changeCodeTextFilter,
  changeDescriptionTextFilter,
  changeMotorTextFilter,
  changeBrandTextFilter,
  changeOriginTextFilter,
  changePartsListPage,
  changePartsListPageSize,
})(PartsAnalysisList);
